module.exports = __webpack_public_path__ + "static/boss4.6d6fdbbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/boss4.png
// module id = 3049
// module chunks = 219286714057974